import {Injectable} from '@angular/core';
import {BASE_URL} from '../constants';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {htmlDocument} from '../../models/htmlDocument.model';
import {map} from 'rxjs/operators';
import {DetectedObject} from '../../models/imageDocument.model';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  URL = BASE_URL + '/image/';
  constructor(private http: HttpClient) { }

  public getVideo(docId: string): Observable<htmlDocument> {
    let params = new HttpParams();
    params = params.append('id', docId);
    return this.http.get<any>(this.URL + 'get_video/', { params: params }).pipe(map(res => res));
  }

  public getImage(docId: string): Observable<htmlDocument> {
    let params = new HttpParams();
    params = params.append('id', docId);
    return this.http.get<any>(this.URL + 'get_image/', { params: params }).pipe(map(res => res));
  }

  public getModelSettings(model: string): Observable<any> {
    return this.http.get<any>(this.URL + 'settings/' + model).pipe(map(res => res));
  }

  public getUserSettings(): Observable<any> {
    return this.http.get<any>(this.URL + 'user_settings/').pipe(map(res => res));
  }

  public saveUserSettings(settings: any): Observable<any> {
    return this.http.post(this.URL + 'save_settings/', settings).pipe(map(res => res));
  }

  // public detectObject(docId: string, bbox: number[], detectedObjectId): Observable<any> {
  //   const params = {docId, bbox, detectedObjectId};
  //   return this.http.post<any>(this.URL + 'image_detect_object/', params);
  // }

  public updateImageDetectedObjects(docId: string, deletedIds: number[], detectedItems: DetectedObject[]): Observable<any> {
    const params = {doc_id: docId, deleted_ids: deletedIds, detected_items: {objects: detectedItems}};
    return this.http.post<any>(this.URL + 'update_image_detected_objects/', params);
  }
}
